<template>
    <div>
        <b-card title="Datos de los responsables" class="">
            <b-card-text class="pt-3 pl-1 d-md-flex">
                <div class="col-md-6 col-sm-12 col-xs-12">
                    <h6>Responsable 1</h6>
                    <p> <b>Nombre:</b> {{ base.nombre_responsable }}</p>
                    <p> <b>Apellidos:</b> {{ base.apellidos_responsable }}</p>
                    <p> <b>DNI:</b> {{ base.dni_responsable }}</p>
                    <p> <b>Email:</b> {{ base.email_responsable }}</p>
                    <p> <b>Teléfono:</b> {{ base.telefono_responsable }}</p>
                </div>
                <div v-if="base.nombre_responsable_2" class="col-md-6 col-sm-12 col-xs-12">
                    <h6>Responsable 2</h6>
                    <p> <b>Nombre:</b> {{ base.nombre_responsable_2 }}</p>
                    <p> <b>Apellidos:</b> {{ base.apellidos_responsable_2 }}</p>
                    <p> <b>DNI:</b> {{ base.dni_responsable_2 }}</p>
                    <p> <b>Email:</b> {{ base.email_responsable_2 }}</p>
                    <p> <b>Teléfono:</b> {{ base.telefono_responsable_2 }}</p>
                </div>
            </b-card-text>
        </b-card>
    </div>
</template>

<script>

    export default {
        props: ['base']
    }
</script>